<ng-container *ngIf="{
    row: columnData | async,
    adata: additionData | async
  } as $">
  <div  class="flex align-items-center" *ngIf="$.row[dataProperty]">
    <span [ngClass]="renderClass( $.row[$.adata.keyName])" class="border-circle mr-2 p-1"></span>
    <span>{{ 'TRANSFER.STATUS.'+$.row[$.adata.keyName] | translate }} </span>
  </div>
</ng-container>
